import React, { useEffect, useState } from "react";
import Card from "components/card";
import { Button, Spinner, Switch } from "@material-tailwind/react";

import { IoEyeSharp } from "react-icons/io5";
import { HiPencilAlt } from "react-icons/hi";
import { FaTrash } from "react-icons/fa";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { ToastContainer, toast } from "react-toastify";

import { Dialog, DialogHeader, DialogBody } from "@material-tailwind/react";

// import PrevisionForm from "./Prevision_form";
import {
  getAllPrevisionApi,
  deletePrevisionApi,
  downloadPrevisionApi,
  downloadPrevisionPDFApi,
} from "api/prevision";
import PrevisionMainTable from "./Modals/Main_table";
import { productTableApi } from "api/dashboard";
import { handlePrevisionValidationApi } from "api/prevision";
import { getOnePrevisionDataApi } from "api/dashboard";
import { MobileTcpTableDataApi } from "api/dashboard";

function PrevisionTable({ accessList }) {
  const [depotFormAction, setDepotFormAction] = useState("show");
  const [showDepotForm, setDepotClientForm] = useState(false);
  const [previsionList, setPrevisionList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDepot, setSelectedDepot] = useState([]);
  const [filerFormData, setFilerFormData] = useState({
    Name: "",
    Origin: "",
    Year: "",
    TCP: "",
  });

  const [filteredPrevisionList, setFilteredPrevisionList] = useState([]);
  const [availableYears, setAvailableYears] = useState([]);
  const [availableTCPs, setAvailableTCPs] = useState([]);

  const [TcpId, setTcpId] = useState(null);

  useEffect(() => {
    getTableData(filerFormData.Name, filerFormData.Origin);
  }, []);

  const getTableData = async (Name, Origin) => {
    try {
      const response = await getAllPrevisionApi();

      if (!response.data) return setPrevisionList([]);

      setPrevisionList(response.data);

      // Extract available years and TCPs for filters
      const years = [
        ...new Set(
          response.data
            .map((item) => (item.Created ? item.Created.split("/")[2] : null))
            .filter(Boolean)
        ),
      ].sort((a, b) => b - a); // Sort years descending

      const tcps = [
        ...new Set(
          response.data.map((item) => item.CommercialName).filter(Boolean)
        ),
      ].sort(); // Sort TCPs alphabetically

      setAvailableYears(years);
      setAvailableTCPs(tcps);
      setFilteredPrevisionList(response.data);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteDepot = (id) => {
    try {
      withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Supprimer ?",
          confirmButtonText: "Supprimer",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await deletePrevisionApi(id);
            getTableData(filerFormData.Name, filerFormData.Origin);
            Swal.fire("Supprimée", "", "success");
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  const getQuartersDateRanges = (year) => {
    const quarters = [];

    // Q1: January 1 - March 31 (or last day of March)
    const q1Start = new Date(year, 0, 1); // January 1st
    const q1End = new Date(year, 3, 0); // Last day of March (month 2, day 0 = last day of previous month)
    quarters.push({
      quarter: 'Q1',
      startDate: formatDate(q1Start),
      endDate: formatDate(q1End)
    });
    
    // Q2: April 1 - June 30 (or last day of June)
    const q2Start = new Date(year, 3, 1); // April 1st
    const q2End = new Date(year, 6, 0); // Last day of June (month 5, day 0 = last day of previous month)
    quarters.push({
      quarter: 'Q2',
      startDate: formatDate(q2Start),
      endDate: formatDate(q2End)
    });
    
    // Q3: July 1 - September 30 (or last day of September)
    const q3Start = new Date(year, 6, 1); // July 1st
    const q3End = new Date(year, 9, 0); // Last day of September (month 8, day 0 = last day of previous month)
    quarters.push({
      quarter: 'Q3',
      startDate: formatDate(q3Start),
      endDate: formatDate(q3End)
    });
    
    // Q4: October 1 - December 31 (or last day of December)
    const q4Start = new Date(year, 9, 1); // October 1st
    const q4End = new Date(year, 12, 0); // Last day of December (month 11, day 0 = last day of previous month)
    quarters.push({
      quarter: 'Q4',
      startDate: formatDate(q4Start),
      endDate: formatDate(q4End)
    });
    
    return quarters;
  };

  const handleDownloadComparaisonPrevisionExcel = async (data) => {
    try {
      const selectedProductsString = ""
      const selectedYear = new Date().getFullYear()

      const quarters = getQuartersDateRanges(selectedYear);

      const productAvrPriceFromYear = new Date(selectedYear-1, 0, 1)
      const formatedProductAvrPriceFromYear = formatDate(productAvrPriceFromYear)
      const productAvrPriceToYear = new Date(selectedYear-1, 12, 0)
      const formatedProductAvrPriceToYear = formatDate(productAvrPriceToYear)

      // 'all'
      const productTableDataPrevYearResponse = await productTableApi(data.for, 'Tout', formatedProductAvrPriceFromYear, formatedProductAvrPriceToYear, selectedProductsString);
      
      // Q1: January 1 - March 31
      const productTableDataQ1Response = await productTableApi(data.for, 'Tout', quarters[0].startDate, quarters[0].endDate, selectedProductsString);

      // Q2: April 1 - June 30
      const productTableDataQ2Response = await productTableApi(data.for, 'Tout', quarters[1].startDate, quarters[1].endDate, selectedProductsString);

      // Q3: July 1 - September 30
      const productTableDataQ3Response = await productTableApi(data.for, 'Tout', quarters[2].startDate, quarters[2].endDate, selectedProductsString);

      // Q4: October 1 - December 31
      const productTableDataQ4Response = await productTableApi(data.for, 'Tout', quarters[3].startDate, quarters[3].endDate, selectedProductsString);

      const objectBody = {
        for: data.for,
        year: selectedYear
      };
      const tcpPrevisionResponse = await getOnePrevisionDataApi(objectBody);

      const tableResponse = await MobileTcpTableDataApi(productTableDataPrevYearResponse, productTableDataQ1Response, productTableDataQ2Response, productTableDataQ3Response, productTableDataQ4Response, tcpPrevisionResponse, selectedProductsString);
      const tableData = tableResponse?.data || tableResponse || {};

      const headers = [
        "Statut",
        "TCP",
        "Produit",
        "Code",
        "Emb",
        "Unité",
        "Q1",
        "Q2",
        "Q3",
        "Q4",
        "Total 1",
        "Q1",
        "Q2",
        "Q3",
        "Q4",
        "Total 2",
        "Marge",
      ];

      const toNumber = (v) => {
        const n = parseFloat(String(v).replace(",", "."));
        return Number.isFinite(n) ? n : 0;
      };

      const buildSection = (title, rows) => {
        const section = [];
        section.push([title]);
        section.push(headers);

        const totals = {
          Q1: 0,
          Q2: 0,
          Q3: 0,
          Q4: 0,
          Total1: 0,
          Q5: 0,
          Q6: 0,
          Q7: 0,
          Q8: 0,
          Total2: 0,
          Margin: 0,
        };

        (rows || []).forEach((row) => {
          const rQ1 = toNumber(row?.Q1);
          const rQ2 = toNumber(row?.Q2);
          const rQ3 = toNumber(row?.Q3);
          const rQ4 = toNumber(row?.Q4);
          const rT1 = toNumber(row?.Total1);
          const rQ5 = toNumber(row?.Q5);
          const rQ6 = toNumber(row?.Q6);
          const rQ7 = toNumber(row?.Q7);
          const rQ8 = toNumber(row?.Q8);
          const rT2 = toNumber(row?.Total2);
          const rM = toNumber(row?.Margin);

          totals.Q1 += rQ1;
          totals.Q2 += rQ2;
          totals.Q3 += rQ3;
          totals.Q4 += rQ4;
          totals.Total1 += rT1;
          totals.Q5 += rQ5;
          totals.Q6 += rQ6;
          totals.Q7 += rQ7;
          totals.Q8 += rQ8;
          totals.Total2 += rT2;
          totals.Margin += rM;

          section.push([
            row?.Status ? "OK" : "-",
            row?.TCP ?? "",
            row?.ProductName ?? "",
            row?.prodductCode ?? row?.productCode ?? "",
            row?.productEmballage ?? "",
            row?.productUnity ?? "",
            rQ1,
            rQ2,
            rQ3,
            rQ4,
            rT1,
            rQ5,
            rQ6,
            rQ7,
            rQ8,
            rT2,
            rM,
          ]);
        });

        if ((rows || []).length > 0) {
          section.push([
            "TOTAL",
            "-",
            "-",
            "-",
            "-",
            "-",
            totals.Q1.toFixed(2),
            totals.Q2.toFixed(2),
            totals.Q3.toFixed(2),
            totals.Q4.toFixed(2),
            totals.Total1.toFixed(2),
            totals.Q5.toFixed(2),
            totals.Q6.toFixed(2),
            totals.Q7.toFixed(2),
            totals.Q8.toFixed(2),
            totals.Total2.toFixed(2),
            totals.Margin.toFixed(2),
          ]);
        }

        return section;
      };

      const xlsxRows = [];
      const qtyRows = tableData?.selectedProductsTableByQuantity || [];
      const amtRows = tableData?.selectedProductsTableByAmount || [];

      xlsxRows.push(...buildSection("Produits sélectionnés (Quantité)", qtyRows));
      xlsxRows.push([]);
      xlsxRows.push(...buildSection("Produits sélectionnés (Montant)", amtRows));

      try {
        const xlsxMod = await import("xlsx");
        const XLSX = xlsxMod.default || xlsxMod;

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(xlsxRows);
        XLSX.utils.book_append_sheet(wb, ws, "Comparaison");

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Comparaison_${data?.CommercialName || data?.for || "TCP"}_${selectedYear}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error("XLSX export failed, ensure 'xlsx' is installed:", e);
      }
    } catch (err) { 
      console.log(err);
    }
  };

  const handleDepotModal = (action, data) => {
    try {
      setTcpId(data?.for);

      setDepotClientForm(!showDepotForm);
      setDepotFormAction(action);

      setSelectedDepot(data);
    } catch (err) {
      console.log(err);
    }
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleDownloadPrevision = async (data) => {
    try {
      setIsLoading(true);

      // Extract year from Created field (format: DD/MM/YYYY)
      const year = data.Created
      ? data.Created.split("/")[2]
      : new Date().getFullYear();

      const productAvrPriceFromYear = new Date(year-1, 0, 1)
      const formatedProductAvrPriceFromYear = formatDate(productAvrPriceFromYear)
      const productAvrPriceToYear = new Date(year-1, 12, 0)
      const formatedProductAvrPriceToYear = formatDate(productAvrPriceToYear)

      const productsDetailsRes = await productTableApi(
        "all",
        "Tout",
        formatedProductAvrPriceFromYear,
        formatedProductAvrPriceToYear
      );

      const response = await downloadPrevisionApi(
        data.for,
        productsDetailsRes.data,
        year
      );
      window.open(response, "_blank");
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadPrevisionPDF = async (data) => {
    try {
      setIsLoading(true);
      const year = data.Created
        ? data.Created.split("/")[2]
        : new Date().getFullYear();

      const productsDetailsRes = await productTableApi(
        "all",
        "Tout",
        null,
        null
      );
      const pdfUrlRes = await downloadPrevisionPDFApi(
        data.for,
        year,
        productsDetailsRes.data
      );

      // Open PDF in new tab
      window.open(`${pdfUrlRes}`, "_blank");

      // Clean up the blob URL after a delay
      setTimeout(() => {
        URL.revokeObjectURL(pdfUrlRes);
      }, 1000);
    } catch (error) {
      console.log(error);
      hadleShowToast("Erreur lors du téléchargement du PDF", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrevisionValidation = async (data) => {
    try {
      setIsLoading(true);
      await withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Valider cette prévision ?",
          showCancelButton: true,
          confirmButtonText: "Valider",
          cancelButtonText: "Annuler",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await handlePrevisionValidationApi(data._id, "V");
            await getTableData(filerFormData.Name, filerFormData.Origin);
            Swal.fire("Validée", "La prévision a été validée", "success");
          }
        });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrevisionAnnulation = async (data) => {
    try {
      setIsLoading(true);
      await withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Annuler cette prévision ?",
          showCancelButton: true,
          confirmButtonText: "Confirmer",
          cancelButtonText: "Retour",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await handlePrevisionValidationApi(data._id, "A");
            await getTableData(filerFormData.Name, filerFormData.Origin);
            Swal.fire("Annulée", "La prévision a été annulée", "success");
          }
        });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const hadleShowToast = (type, message) => {
    if (type === "success") {
      setDepotClientForm(!showDepotForm);
      getTableData(filerFormData.Name, filerFormData.Origin);

      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (type === "error") {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const handleFilterChange = (field, value) => {
    const newFilterData = { ...filerFormData, [field]: value };
    setFilerFormData(newFilterData);

    // Apply filters
    let filtered = previsionList;

    if (newFilterData.Year) {
      filtered = filtered.filter(
        (item) =>
          item.Created && item.Created.split("/")[2] === newFilterData.Year
      );
    }

    if (newFilterData.TCP) {
      filtered = filtered.filter(
        (item) =>
          item.CommercialName &&
          item.CommercialName.toLowerCase().includes(
            newFilterData.TCP.toLowerCase()
          )
      );
    }

    setFilteredPrevisionList(filtered);
  };

  const clearFilters = () => {
    setFilerFormData({
      Name: "",
      Origin: "",
      Year: "",
      TCP: "",
    });
    setFilteredPrevisionList(previsionList);
  };

  return (
    <Card extra={"w-full pb-10 p-4 h-full"}>
      <ToastContainer />
      <Dialog size="xl" open={showDepotForm} handler={handleDepotModal}>
        <DialogHeader>
          <p className="w-full text-center">
            {depotFormAction === "add"
              ? "Nouveau dépôt"
              : depotFormAction === "edite"
              ? "Modifier la prévision"
              : "Voir les details de prévision"}
          </p>
        </DialogHeader>
        <DialogBody>
          <PrevisionMainTable
            closePopup={handleDepotModal}
            depotFormAction={depotFormAction}
            showToast={hadleShowToast}
            selectedReport={selectedDepot}
            TcpId={TcpId}
          />
        </DialogBody>
      </Dialog>

      <header className="relative flex flex-col items-center justify-between md:flex-row">
        <div className="mb-5 text-xl font-bold text-navy-700 dark:text-white md:mb-0"></div>
        {/* {accessList.Add && (
          <Button
            onClick={() => handleDepotModal("add", null)}
            className="linear mb-5 rounded-[10px] bg-gray-500 px-4 py-2 text-xs font-bold text-white transition duration-200 hover:bg-gray-400 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:mb-0"
          >
            Nouveau dépôts
          </Button>
        )} */}
      </header>

      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2"></div>

      {/* Filter Section */}
      <div className="mt-8 mb-6 rounded-lg border border-gray-200 bg-gray-50 p-4">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <div className="flex flex-col items-center gap-4 md:flex-row">
            {/* Year Filter */}
            <div className="flex min-w-[150px] flex-col">
              <label className="mb-1 text-sm font-medium text-gray-700">
                Année
              </label>
              <select
                value={filerFormData.Year}
                onChange={(e) => handleFilterChange("Year", e.target.value)}
                className="focus:border-transparent rounded-md border border-gray-300 bg-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Toutes les années</option>
                {availableYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            {/* TCP Filter */}
            <div className="flex min-w-[200px] flex-col">
              <label className="mb-1 text-sm font-medium text-gray-700">
                TCP
              </label>
              <input
                type="text"
                placeholder="Rechercher par TCP..."
                value={filerFormData.TCP}
                onChange={(e) => handleFilterChange("TCP", e.target.value)}
                className="focus:border-transparent rounded-md border border-gray-300 bg-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          {/* Clear Filters Button */}
          <button
            onClick={clearFilters}
            className="rounded-md bg-gray-500 px-4 py-2 font-medium text-white transition-colors duration-200 hover:bg-gray-600"
          >
            Effacer les filtres
          </button>
        </div>

        {/* Results Count */}
        <div className="mt-4 flex items-center justify-between text-sm text-gray-600">
          <span>
            {filteredPrevisionList.length} résultat(s) sur{" "}
            {previsionList.length} prévision(s)
            {(filerFormData.Year || filerFormData.TCP) && (
              <span className="ml-2 font-medium text-blue-600">
                (Filtres actifs)
              </span>
            )}
          </span>
          {(filerFormData.Year || filerFormData.TCP) && (
            <span className="text-xs text-gray-500">
              Appuyez sur "Effacer les filtres" pour voir tous les résultats
            </span>
          )}
        </div>
      </div>

      <div className="mt-8 overflow-x-scroll">
        {isLoading ? (
          <div className="flex w-full items-center justify-center">
            <Spinner className="h-12 w-12" />
          </div>
        ) : (
          <div
            className="mt-8 overflow-x-scroll"
            style={{ height: "50vh", overflowY: "scroll" }}
          >
            <table className="w-full">
              <thead>
                <tr>
                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">TCP</p>
                  </th>

                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">Année</p>
                  </th>

                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">
                      Prévision
                    </p>
                  </th>

                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">
                      Actions
                    </p>
                  </th>
                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">
                      Status
                    </p>
                  </th>
                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">
                      Comparaison
                    </p>
                  </th>
                </tr>
              </thead>

              <tbody>
                {filteredPrevisionList.map((el, index) => {
                  // Determine row background color based on validation status
                  let rowClassName = "";
                  if (el.Dcommercial === "V" || el.EtatDgeneral === "V") {
                    rowClassName = "bg-green-100 hover:bg-green-200";
                  } else if (
                    el.Dcommercial === "A" ||
                    el.EtatDgeneral === "A"
                  ) {
                    rowClassName = "bg-red-100 hover:bg-red-200";
                  }

                  return (
                    <tr key={el._id || index} className={rowClassName}>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {el.CommercialName}
                        </p>
                      </td>

                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {el.Created ? el.Created.split("/")[2] : "-"}
                        </p>
                      </td>

                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <div className="flex gap-2">
                          <Button
                            variant="gradient"
                            color="#236571"
                            className="mr-1"
                            onClick={() => handleDownloadPrevision(el)}
                          >
                            <span>Excel</span>
                          </Button>
                          <Button
                            variant="gradient"
                            color="#dc2626"
                            className="mr-1"
                            onClick={() => handleDownloadPrevisionPDF(el)}
                          >
                            <span>PDF</span>
                          </Button>
                        </div>
                      </td>

                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          <div className="flex">
                            {accessList.Read && (
                              <IoEyeSharp
                                size={20}
                                color="gray"
                                className="cursor-pointer"
                                onClick={() => handleDepotModal("show", el)}
                              />
                            )}
                            {accessList.Update && (
                              <HiPencilAlt
                                size={20}
                                color="#236571"
                                className="ml-4 mr-4 cursor-pointer"
                                onClick={() => handleDepotModal("edite", el)}
                              />
                            )}
                            {accessList.Delete && (
                              <FaTrash
                                size={20}
                                color="#cf503f"
                                className="cursor-pointer"
                                onClick={() => handleDeleteDepot(el._id)}
                              />
                            )}
                          </div>
                        </p>
                      </td>

                      {el.Dcommercial === "N" && el.EtatDgeneral === "N" && (
                        <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                          <div className="flex gap-2">
                            <Button
                              variant="gradient"
                              color="#236571"
                              className="mr-1"
                              onClick={() => handlePrevisionValidation(el)}
                            >
                              <span>Valider</span>
                            </Button>
                            <Button
                              variant="gradient"
                              color="#dc2626"
                              className="mr-1"
                              onClick={() => handlePrevisionAnnulation(el)}
                            >
                              <span>Annuler</span>
                            </Button>
                          </div>
                        </td>
                      )}

                      {(el.Dcommercial === "V" || el.EtatDgeneral === "V") && (
                        <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                          <div className="flex gap-2">
                            <Button
                              variant="gradient"
                              color="#236571"
                              className="mr-1"
                              disabled
                            >
                              <span>Validée</span>
                            </Button>
                          </div>
                        </td>
                      )}

                      {(el.Dcommercial === "A" || el.EtatDgeneral === "A") && (
                        <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                          <div className="flex gap-2">
                            <Button
                              variant="gradient"
                              color="#dc2626"
                              className="mr-1"
                              disabled
                            >
                              <span>Annulée</span>
                            </Button>
                          </div>
                        </td>
                      )}

                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <div className="flex gap-2">
                          <Button
                            variant="gradient"
                            color="#dc2626"
                            className="mr-1"
                            onClick={() =>
                              handleDownloadComparaisonPrevisionExcel(el)
                            }
                          >
                            <span>Excel</span>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Card>
  );
}

export default PrevisionTable;
